import { Controller } from "@hotwired/stimulus";
import { trackProofEvent } from "../proof_events.js";

export default class extends Controller {
  static values = { event: String, offer: { type: String, default: "other" }, view: Boolean };
  connect() {
    if (this.viewValue) trackProofEvent(this.eventValue, this.offerValue);
  }
  track() {
    trackProofEvent(this.eventValue, this.offerValue);
  }
}
